<template>
    <div class="bd">

        <div class="my-custom-table">
            <a-page-header title="日志列表" />
            <div class="search-bar">
                <div class="tabInput">
                    <a>操作人：</a>
                    <a-input v-model:value="optionUser" placeholder="请输入操作人进行搜索" class="search-input" />
                </div>
                <div class="tabInput">
                    <a>开始时间：</a>
                    <a-date-picker  type="dateTime" v-model:value="startDate" showTime  valueFormat="YYYY-MM-DD HH:mm:ss" placeholder="请选择开始时间" class="search-input" />
                </div>
                <div class="tabInput">
                    <a>结束时间：</a>
                    <a-date-picker  type="dateTime" v-model:value="endDate" showTime  valueFormat="YYYY-MM-DD HH:mm:ss" placeholder="请选择结束时间" class="search-input" />
                </div>
                <div class="tab-button">
                    <div>
                        <a-button class="search-tow" type="primary" @click="onSearch"
                            :icon="h(SearchOutlined)">搜索</a-button>
                        <a-button class="search-tow" @click="onReset" :icon="h(RedoOutlined)">重置</a-button>
                    </div>
                </div>
            </div>

            <a-table :columns="columns" :data-source="data" :pagination="pagination" row-key="id">
                <template #bodyCell="{ column, record }">
                    <template v-if="column.dataIndex === 'optionType'">
                        <span>
                            <a-tag color="green">
                                {{ record.optionType }}
                            </a-tag>
                        </span>
                    </template>
                    <!-- 渲染操作按钮 -->
                    <template v-if="column.dataIndex === 'operation'">
                        <div class="editable-row-operations">
                            <a style="margin: 15px;" @click="details(record.id)">查看详情</a>
                        </div>
                    </template>
                </template>
            </a-table>

            <!-- 详情弹窗 -->
            <a-modal v-model:open="detailsOpen" title="日志详情" ok-text="了解" cancel-text="取消" @ok="hideModal">
                <div class="detail-container">
                    <table class="detail-table">
                        <tbody>
                            <tr>
                                <th>ID</th>
                                <td>{{ dataSource.id }}</td>
                            </tr>
                            <tr>
                                <th>模型</th>
                                <td>{{ dataSource.model }}</td>
                            </tr>
                            <tr>
                                <th>操作类型</th>
                                <td>{{ dataSource.optionType }}</td>
                            </tr>
                            <tr>
                                <th>操作用户</th>
                                <td>{{ dataSource.optionUser }}</td>
                            </tr>
                            <tr>
                                <th>IP地址</th>
                                <td>{{ dataSource.optionIp }}</td>
                            </tr>
                            <tr>
                                <th>操作时间</th>
                                <td>{{ dataSource.optionTime }}</td>
                            </tr>
                            <tr>
                                <th>操作内容</th>
                                <td>{{ dataSource.optionContent }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </a-modal>
        </div>
    </div>
</template>


<script>
import { logPage, logs } from '@/api/service'
import { SearchOutlined, RedoOutlined, PlusCircleOutlined } from '@ant-design/icons-vue';
import { ref, h } from 'vue';
export default {
    name: 'LogPage',
    setup() {
        const data = ref([]); // 初始化为空数组
        const dataSource = ref([]);//详细信息数据
        const detailsOpen = ref(false);
        const optionUser = ref('');//查询条件
        const startDate = ref('');//查询条件
        const endDate = ref('');//查询条件
        const pagination = ref({
            current: 1, // 当前页数
            pageSize: 10, // 每页显示条数
            total: 0, // 数据总数
            showSizeChanger: true, // 是否显示修改每页条数
            showQuickJumper: true, // 是否显示快速跳转
            onChange: (page, pageSize) => {
                pagination.value.current = page;
                pagination.value.pageSize = pageSize;
                list(); // 当分页改变时，重新获取数据
            },
            position: ['bottomLeft']//显示位置
        });
        //列表
        const columns = [
            { title: '模块名称', dataIndex: 'model', key: 'model', width: '20%', },
            { title: '操作类型', dataIndex: 'optionType', key: 'optionType', width: '20%', },
            { title: '操作人', dataIndex: 'optionUser', key: 'optionUser', width: '20%', },
            { title: '操作地址', dataIndex: 'optionIp', key: 'optionIp', width: '10%', },
            { title: '操作时间', dataIndex: 'optionTime', key: 'optionTime', width: '20%', },
            { title: '操作', dataIndex: 'operation', width: '20%', },
        ];
        //查询数据
        const list = async () => {
            const response = await logPage({
                pageNumber: pagination.value.current,
                pageSize: pagination.value.pageSize,
                optionUser: optionUser.value,
                startTime: startDate.value,
                endTime: endDate.value
            });
            if (response.code === 200) {
                pagination.value.total = response.totalRow || response.data.totalRow || response.data.total || 0; // 更新 total
                data.value = response.data.records.map(item => ({
                    id: item.id,
                    model: item.model,
                    optionType: item.optionType,
                    optionUser: item.optionUser,
                    optionIp: item.optionIp,
                    optionTime: item.optionTime
                }));
            }
        };
        //查询详细信息
        const details = async (id) => {
            const response = await logs(id);
            if (response.code === 200) {
                dataSource.value = response.data;
            }
            detailsOpen.value = true;
        };
        // 组件初始化时调用一次
        list();

        //搜索
        const onSearch = () => {
            pagination.value.current = 1; // 搜索时重置当前页数
            list();
        }
        //重置
        const onReset = () => {
            optionUser.value = ''; // 重置搜索关键词
            list(); // 重置后重新获取数据
        }
        //关闭详情
        const hideModal = () => {
            detailsOpen.value = false;
        };
        return {
            SearchOutlined,
            RedoOutlined,
            PlusCircleOutlined,
            optionUser,
            startDate,
            endDate,
            data,
            dataSource,
            h,
            columns,
            onSearch,
            onReset,
            details,
            detailsOpen,
            pagination,
            hideModal
        }
    }
}
</script>
<style>
.detail-container {
    padding: 16px;
}

.detail-table {
    width: 100%;
    border-collapse: collapse;
}

.detail-table th,
.detail-table td {
    padding: 8px;
    border: 1px solid #ddd;
    text-align: left;
}

.detail-table th {
    background-color: #1890ff;
    color: white;
}
</style>